/**
 * Products we may not sell in particular markets — a regulatory formality, so
 * the product page swaps Add to Cart for an "unavailable in your region"
 * message there, and that market's Google Merchant feed leaves them out. The
 * product stays listed on the storefront, and nothing stops it at the API or
 * in checkout.
 *
 * TEMPORARY. Spree 6.1 plans product-level market availability natively
 * (spree/spree#14613, docs/plans/6.1-product-market-availability.md). Once we
 * upgrade, set these in the Spree admin and delete this file and its callers
 * in ProductDetails and the feed route. Note 6.1 hides an excluded product
 * entirely rather than showing a message.
 *
 * Keys are product slugs; values are Spree market names, as set in the admin.
 * A renamed market silently lifts its restrictions.
 */
const UNAVAILABLE_IN_MARKETS: Record<string, readonly string[]> = {
  "tongkat-ali": ["Europe", "United Kingdom"], // TKA 2.4e™
  "btt-pro": ["Europe"], // BTT Pro™ (Tribulus)
};

/** True when the product must not be sold in the given market. */
export function isUnavailableInMarket(
  productSlug: string,
  marketName: string | null | undefined,
): boolean {
  if (!marketName) return false;
  return UNAVAILABLE_IN_MARKETS[productSlug]?.includes(marketName) ?? false;
}
